export default "__VITE_ASSET__4e220f8e__"